<template>
    <v-data-table
        dense
        :headers="headers"
        :items="value"
        :loading="loading"
        hide-default-footer
        disable-pagination
        disable-sort
    >
        <template v-slot:[`item.name`]="{item}">
            <v-btn icon color="primary" @click="handleRowClick(item)" v-if="hasPermission(perm.supplier_account.read)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.display_name}}
        </template>
        <template v-slot:[`item.actions`]="{item}">
            <v-btn text small color="primary" @click="handleStatement(item)">
                <v-icon left>mdi-cash</v-icon>
                account statement
            </v-btn>
        </template>
    </v-data-table>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import permissions from './../../data/permissions';
import moment from 'moment';

export default {
    name: "SupplierAccountList",
    props: {
        value: Array,
        supplierId: [String, Number]
    },
    data() {
        return {
            loading: false,
            headers: [
                { text: "Account Name", value: "name"},
                { text: "Currency", value: "currency.abbreviation"},
                { text: "", value: "actions" }
            ],
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions("purchase/supplierAccountStatement", {
            initSupplierStatement: "init"
        }),
        handleRowClick(item) {
            this.$router.push({ name: "SupplierAccountDisplay", params: { id: item.id }})
        },
        handleStatement(item) {
            this.initSupplierStatement({
                supplier_id: this.supplierId,
                account_id: item.id,
                from: moment().startOf("year").format("YYYY-MM-DD"),
                to: moment().format("YYYY-MM-DD")
            })
            this.$router.push({ name: "SupplierAccountStatementView" })
        }
    }
}
</script>

<style>

</style>